
export const checkBrowserType = () => {
  const isBrave = navigator.brave || (navigator.userAgent && navigator.userAgent.includes('Brave'));
  const choseIgnoreBrave = !!localStorage.getItem('dismissBrave');
  return ({ isBrave, choseIgnoreBrave });
};
